import React, { createContext, useState } from 'react';
export const EmployeeDispatcherContext = createContext();
export const EmployeeContext = createContext('Default Value');
import PropTypes from 'prop-types';

const initialData = 'default context value';
const CustomerProvider = ({ children }) => {
  const [state, setState] = useState(initialData);

  return (
    <EmployeeContext.Provider value={state}>
      <EmployeeDispatcherContext.Provider value={setState}>
        {children}
      </EmployeeDispatcherContext.Provider>
    </EmployeeContext.Provider>
  );
};
// CustomerProvider.propTypes = {
//   //   customerData: PropTypes.object,
//   children: PropTypes.node,
// };
// CustomerProvider.defaultProps = {
//   //   customerData: {},
//   children: null,
// };
export default CustomerProvider;
